import { useEffect } from "react";
import { toast } from "sonner";

/**
 * Compatibility toast: when `message` is set, fire a Sonner toast once.
 * Prefer calling `toast()` directly in new code.
 */
export function Toast({ message, type = "success", onClose, duration = 3000 }) {
  useEffect(() => {
    if (!message) return undefined;

    const id = type === "error" || type === "danger"
      ? toast.error(message, { duration })
      : toast.success(message, { duration });

    const timer = setTimeout(() => {
      onClose?.();
    }, duration);

    return () => {
      clearTimeout(timer);
      toast.dismiss(id);
    };
  }, [message, type, duration, onClose]);

  return null;
}
